import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a0f3b2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lang" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "globe",
  slot: "reference"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: "/globe_32.png" })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "language-warning"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", {
      class: "lang-select",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.onLanguageClick('en')))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.selectedLanguage == 'English' ? 'selected' : '')
      }, "English", 2)
    ]),
    _createElementVNode("span", {
      class: "lang-select",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.onLanguageClick('ro')))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.selectedLanguage == 'Română' ? 'selected' : '')
      }, "Română", 2)
    ]),
    _createElementVNode("span", {
      class: "lang-select",
      onClick: _cache[2] || (_cache[2] = $event => (_ctx.onLanguageClick('uk')))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.selectedLanguage == 'українська' ? 'selected' : '')
      }, "українська", 2)
    ]),
    (_ctx.isUnavailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.hintText), 1))
      : _createCommentVNode("", true)
  ]))
}